import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { ShieldAlert } from 'lucide-react';

// Masked manager PIN (+ optional reason) — same fields as VoidLastOrderDialog; the server verifies the PIN.
export function ManagerApprovalDialog({ request, onClose }) {
  const [pin, setPin] = useState('');
  const [reason, setReason] = useState('');
  useEffect(() => { setPin(''); setReason(''); }, [request]);
  const done = (result) => { request?.resolve(result); onClose(); };
  const canSubmit = (request?.noPin || pin.length >= 4) && (!request?.needReason || reason.trim());
  return (
    <Dialog open={!!request} onOpenChange={(o) => { if (!o) done(null); }}>
      <DialogContent className="max-w-md" data-testid="manager-approval-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><ShieldAlert className="w-5 h-5 text-amber-600" /> {request?.title || 'Manager approval'}</DialogTitle>
          {request?.detail && <DialogDescription data-testid="manager-approval-detail">{request.detail}</DialogDescription>}
        </DialogHeader>
        <div className="space-y-3">
          {!request?.noPin && <div>
            <Label htmlFor="mgr-pin">Manager PIN</Label>
            <Input id="mgr-pin" type="password" inputMode="numeric" autoComplete="off" autoFocus value={pin}
              onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 8))} className="h-12 text-lg tracking-widest"
              data-testid="manager-approval-pin" />
          </div>}
          {request?.needReason && (
            <div>
              <Label htmlFor="mgr-reason">Reason (required)</Label>
              <Textarea id="mgr-reason" rows={2} value={reason} onChange={(e) => setReason(e.target.value)} data-testid="manager-approval-reason" />
            </div>
          )}
          <div className="flex gap-2">
            <Button variant="outline" className="h-11 flex-1" onClick={() => done(null)} data-testid="manager-approval-cancel">Cancel</Button>
            <Button className="h-11 flex-1" disabled={!canSubmit} onClick={() => done({ pin, reason: reason.trim() })} data-testid="manager-approval-confirm">
              Approve
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
